<template>
  <div  v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)" >
    <div id="uoloaddiv34" align="left" >


		 <el-button type="button" @click="dialogVisible = true">添加文字转语音 </el-button>

			<el-dialog
				title="添加文字转语音"
				:visible.sync="dialogVisible"
				width="50%"
				>

				<div>
					<el-tag type="warning">文字转语音要保存的文件名</el-tag><el-input placeholder="请输入保存的资源名称" v-model="inputfilename">
						<template slot="prepend">SRC-NAME:</template>
					</el-input>
				</div>
				<br><el-tag>男声女声选择：</el-tag>
				 <el-select v-model="valueshengyin"  >
					<el-option
					  v-for="item in optionsshengyin"
					  :key="item.value"
					  :label="item.label"
					  :value="item.value">
					</el-option>
				 </el-select>  <el-tag>语速：</el-tag>
				 <el-select v-model="valueyusu"  >
				 					<el-option
				 					  v-for="item in optionsyusu"
				 					  :key="item.value"
				 					  :label="item.label"
				 					  :value="item.value">
				 					</el-option>
				 </el-select>
				<el-divider></el-divider>
				<el-input
					type="textarea"
					:rows="20"
					placeholder="请输入内容"
					maxlength="2000"
				  show-word-limit
					minlength="3"
					v-model="textarea">
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="add_tty">确 定</el-button>
				</span>
			</el-dialog>



      <div style="padding:10px 0;">
        <a-player
          :autoplay="autoplay"
          :music="songList"
          v-if="flag"
          mutex
          listmaxheight="10px"
          ref="player"
        ></a-player>
      </div>
      <el-table :data="tableDatafilelist" highlight-current-row border style="width: 800px" >
        <el-table-column type="index" width="100" label="编号"></el-table-column>
        <el-table-column prop="filename" label="文件名" width="300"></el-table-column>
        <el-table-column prop="sizeStr" label="文件大小" width="100" ></el-table-column>
        <el-table-column label="试听" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="playurl(scope.$index, tableDatafilelist)"
              type="text"
              size="small"
            >播放</el-button>
          </template>
        </el-table-column>
      <!--  <el-table-column  label="审核" width="100" align="center">
          <template slot-scope="scope">
            <el-switch :disabled="tableDatafilelist[scope.$index].ismasterd == 1 ? true:false"
              active-value="1"
              inactive-value="0"
              v-model="tableDatafilelist[scope.$index].enable"
              @change="abletask( scope.$index, tableDatafilelist)"
            ></el-switch>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
						  :disabled="tableDatafilelist[scope.$index].ismasterd == 1 ? true:false"
              @click.native.prevent="deleteRow(scope.$index, tableDatafilelist)"
              type="text"
              size="small"
            >移除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

</template>

<script>
import VueAplayer from "vue-aplayer";
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
/*if(this.radiovalue1 == "小燕"){
						this.yinse = "xiaoyan";
					}else if(this.radiovalue1 == "许久"){
						this.yinse = "aisjiuxu";
					}else if(this.radiovalue1 == "小萍"){
						this.yinse = "aisxping";
					}else if(this.radiovalue1 == "小婧"){
						this.yinse = "aisjinger";
					}else{
						this.yinse = "xiaoyan";
					}*/
export default {
  components: {
    //别忘了引入组件
    "a-player": VueAplayer
  },
  data() {
    return {
		optionsshengyin: [{
          value: 'xiaoyan',
          label: '讯飞小燕'
        } , {
          value: 'aisjiuxu',
          label: '讯飞徐久'
        } , {
          value: 'aisxping',
          label: '讯飞AI小萍'
        } , {
          value: 'aisjinger',
          label: '讯飞AI小婧'
        }  ],
		optionsyusu: [{
		  value: 50,
		  label: '中'
		}, {
		  value: 35,
		  label: '慢'
		}
		 , {
		   value: 65,
		   label: '快'
		 } ],
	  valueshengyin:"xiaoyan",
	  valueyusu:50,
      flag: false,
      actions: "",
      actionsmp3: "",
			dialogVisible: false,
      userid: 0,

      fileList: [],
			inputfilename:"",
      tableDatafilelist: [],
			textarea:"",
      songList: [],
      autoplay: false,
      isroot: false,
      loading : false
    };
  },

  created() {
    this.userid = sessionStorage.getItem("id");
    this.actions =
    //"http://27.221.110.150:10080/uploader.php?username=" +
	   "/uploader.php?username=" +
		//"http://101.71.162.196:10080/uploader.php?username=" +
      sessionStorage.getItem("username") +
      "&passwd=" +
      sessionStorage.getItem("passwd") +
      "&kind=mp3";
    this.actionsmp3 =
      //"http://27.221.110.150:10080/uploader.php?username=" +
	  "/uploader.php?username=" +
		//"http://101.71.162.196:10080/uploader.php?username=" +
      sessionStorage.getItem("username") +
      "&passwd=" +
      sessionStorage.getItem("passwd") +
      "&kind=mp3";
    this.get_file_list();
    if (sessionStorage.getItem("master_id") == -1) {
      this.isroot = true;
    }
  },
  methods: {
    playurl(index, rows) {
      this.flag = false;
      console.log(rows[index].url);
      console.log(rows[index].filename);
      let obj = {};
      let murl = rows[index].url;
      let lname = rows[index].filename;
      let auth = "试听上传歌曲";
      obj.title = lname;
      obj.author = auth;
      obj.url = murl;
      //把数据一个个push到songList数组中，在a-player标签中使用 :music="songList" 就OK了
      this.songList = obj;
      this.flag = true;
      this.autoplay = true;
    },
		handleClose(){

		},
		add_tty(){
			if(this.filename == ""){
				return;
			}
			if(this.textarea.length < 3){
				return;
			}
      this.loading  = true;
			let data = new FormData();
			data.append("id", sessionStorage.getItem("id"));
			data.append("token", sessionStorage.getItem("token"));
			data.append("vol", 100);
			data.append("text", this.textarea);
			data.append("speed", this.valueyusu);
			data.append("shengyin", this.valueshengyin);
			data.append("filename", this.inputfilename);
			axios
			  .post("/user/savettsfile", data)
			  .then(
			    function(res) {
			      if (res.data.res) {
			        console.log(res);
			        this.$notify.success({
			          title: "Info",
			          message: "添加成功",
			          showClose: false
			        });
			        this.get_file_list();
							this.dialogVisible = false;
              this.loading  = false;
			      } else {
              this.loading  = false;
			        this.$notify.success({
			          title: "Info",
			          message: "添加节点出现异常检查是否重复添加",
			          showClose: false
			        });
			      }
			    }.bind(this)
			  )
			  .catch(function(res) {
			    console.log(res);
			  });
    },
    deleteRow(index, rows) {
     this.$confirm(
       "此操作将永久删除该文件, 是否继续?     " + rows[index].filename,
       "提示",
       {
         confirmButtonText: "确定",
         cancelButtonText: "取消",
         type: "warning"
       }
     )
       .then(() => {
           let data = new FormData();
           data.append("id", sessionStorage.getItem("id"));
           data.append("token", sessionStorage.getItem("token"));
           data.append("fileid",rows[index].id);
         axios
           .post("/user/delfile", data)
           .then(
             function(res) {
               if (res.data.res) {
                 rows.splice(index, 1);
                 this.get_file_list();
                 this.$message({
                   type: "success",
                   message: "删除成功!" + filename
                 });
               }
             }.bind(this)
           )
           .catch(function(res) {
             console.log(res);
           });
       })
       .catch(() => {
         this.$message({
           type: "info",
           message: "已取消删除"
         });
       });
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: "上传文件出错了!",
        type: "error"
      });
    },

    abletask(index, rows) {
      console.log("fuckser");
      axios
        .get("/Change_file_status.php", {
          params: {
            file_id: rows[index].id,
            enable: rows[index].enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this._get_timer_tasklist_s(rows[index].task_enable, index);
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    uploadbefore(file) {
      var fileName = new Array();
      fileName = file.name.split(".");
      const extension = fileName[fileName.length - 1] === "mp3";
      const extension2 = fileName[fileName.length - 1] === "MP3";
      const isLt2M = file.size / 1024 / 1024 < 40;
      fileName = file.name.split(".");
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是MK格式!",
          type: "warning"
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传模板大小不能超过 40MB!",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    uploadbeforemp3(file) {
      var fileName = new Array();
      fileName = file.name.split(".");
      const extension = fileName[fileName.length - 1] === "mp3";
      const extension2 = fileName[fileName.length - 1] === "MP3";
      const isLt2M = file.size / 1024 / 1024 < 40;
      fileName = file.name.split(".");
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是MP3格式!",
          type: "warning"
        });
        return false;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传模板大小不能超过 40MB!",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    uploadSuccess(response, file, fileList) {
      console.log("上传文件", response);
      this.get_file_list();
    },
    uploadSuccessmp3(response, file, fileList) {
      console.log("上传文件", response);
      this.get_file_list();
    },
    get_file_list() {
      if(sessionStorage.getItem("master_id") > 0){
      		this.isroot = false;
      }
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/listfile",  data)
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.filelist;
      				console.log(this.tableDatafilelist);
              // this.tableDatafilelist.forEach((item, index) => {
              //   item.filename = Base64.decode(item.filenamebase64);
              //   item.filesize = item.filesize;
              // });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style  scoped>
#uoloaddiv34 {
  margin: 20px ;
  width: 800px;
}
#topbuttn {
  width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/wenzizhuanyuyin.vue